import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.css', '../../../app.component.css']
})

export class HelpComponent implements OnInit {

    public constructor(public appService: AppService) { }

    public ngOnInit(): void { }
}
